import { CheckOutlined, CloseCircleOutlined } from "@ant-design/icons"
import UserProfileSummary from "../../shared/components/userProfileSummary"
import { Flex } from "antd"
import theme from "utils/themeVars"
import { Card, DateFormat, Group, Icon, Text, Title } from "components/common"
import { t } from "i18next"
import styles from "./index.module.less"
import { Separator } from "../../../components/custom"
import dayjs from "dayjs"

const actionColors = {
  rejected: theme["error-color"],
  approved: theme["primary-color"],
  skipped: "#D6A700",
  pending: undefined,
}

const actionDateTitle = {
  rejected: "Rejected Date",
  approved: "Completed Date",
  skipped: "Skipped Date",
  current: "Deadline",
}

const statusCheck = (type, actionBy) => {
  switch (type) {
    case "pending":
      return "Pending"
    case "rejected":
      return (
        <>
          <CloseCircleOutlined /> {`Rejected By ${actionBy?.name}`} <UserProfileSummary staffId={actionBy?.id} />
        </>
      )
    case "approved":
      return (
        <>
          <CheckOutlined /> {`Approved By ${actionBy?.name}`} <UserProfileSummary staffId={actionBy?.id} />
        </>
      )
    case "skipped":
      return (
        <>
          <CheckOutlined /> {`Skipped By ${actionBy?.name}`} <UserProfileSummary staffId={actionBy?.id} />
        </>
      )
    default:
      return "Current Stage"
  }
}

export const HeaderComponent = ({
  index,
  title,
  turnAroundTime,
  assignedDate,
  status,
  actionBy,
  showStatus,
  actionDate,
}) => {
  const deadLineOverDueDays = Math.max(0, dayjs().diff(dayjs(actionDate), "day"))
  return (
    <Group className="flexYcenter" template={"1fr auto"} gap={30}>
      <Flex align="center" gap="14px">
        <Card
          className={styles.countingCard}
          style={{
            color:
              status === "rejected"
                ? theme["error-color"]
                : status === "approved"
                  ? theme["primary-color"]
                  : status === "current" || status === "skipped"
                    ? "#0391ba"
                    : theme["base-color"],
          }}
        >
          {index + 1}
        </Card>

        <div>
          <Title level={5} className="mbe-0">
            {title}
          </Title>
          {status !== "skipped" && (
            <div className="d-flex flexYcenter gray-700" style={{ gap: "10px" }}>
              {assignedDate && status !== "pending" && (
                <div className="d-flex flexYcenter" style={{ gap: "4px" }}>
                  {t("Assigned On")}
                  <DateFormat date={assignedDate} />
                </div>
              )}
              {assignedDate && turnAroundTime && <Separator />}
              {turnAroundTime && (
                <>
                  <Icon icon="IoTimerOutline" /> {t("TAT: ") + turnAroundTime + t(" Days")}
                </>
              )}
            </div>
          )}
        </div>
      </Flex>
      {showStatus && (
        <Flex vertical>
          <div
            style={{
              color: actionColors[status] ?? "#0091BA",
            }}
          >
            {statusCheck(status, actionBy)}
          </div>
          {actionDate && (
            <Text className="" style={{ gap: "4px", textAlign: "end" }} type="secondaryLight">
              {actionDateTitle[status]}
              <DateFormat
                date={actionDate}
                dateColor={status === "current" && deadLineOverDueDays ? theme["error-color"] : ""}
                customTooltip={
                  status === "current" && deadLineOverDueDays
                    ? () => t("Overdue by ") + deadLineOverDueDays + t(" days")
                    : ""
                }
              />
            </Text>
          )}
        </Flex>
      )}
    </Group>
  )
}
